import { DashboardScheduleStats } from '../../../models';

export const getDashboardScheduleStats = (data: any): DashboardScheduleStats => {
  return {
    todayCount: data.today_count,
    thisMonthCount: data.this_month_count
  };
}
